var sn = Object.defineProperty;
var dn = (e, n, t) => n in e ? sn(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t;
var y = (e, n, t) => (dn(e, typeof n != "symbol" ? n + "" : n, t), t);
var T, A, W, F, D, X = -1, E = function(e) {
  addEventListener("pageshow", function(n) {
    n.persisted && (X = n.timeStamp, e(n));
  }, !0);
}, H = function() {
  return window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
}, N = function() {
  var e = H();
  return e && e.activationStart || 0;
}, m = function(e, n, t, a) {
  var o = H(), i = "navigate";
  return t ? i = t : X >= 0 ? i = "back-forward-cache" : o && (document.prerendering || N() > 0 ? i = "prerender" : document.wasDiscarded ? i = "restore" : o.type && (i = o.type.replace(/_/g, "-"))), { name: e, value: n === void 0 ? -1 : n, rating: "good", delta: 0, entries: [], id: "v3-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12), navigationType: i, navigationId: a || 1 };
}, w = function(e) {
  return PerformanceObserver.supportedEntryTypes.includes("soft-navigation") && (e == null ? void 0 : e.reportSoftNavs);
}, Y = function(e) {
  return e && e !== 1 ? window.performance && performance.getEntriesByType && performance.getEntriesByType("soft-navigation")[e - 2] : window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
}, I = function(e, n, t) {
  var a = w(t);
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(e)) {
      var o = new PerformanceObserver(function(i) {
        Promise.resolve().then(function() {
          n(i.getEntries());
        });
      });
      return o.observe(Object.assign({ type: e, buffered: !0, includeSoftNavigationObservations: a }, t || {})), o;
    }
  } catch {
  }
}, g = function(e, n, t, a) {
  var o, i;
  return function(r) {
    n.value >= 0 && (r || a) && ((i = n.value - (o || 0)) || o === void 0) && (o = n.value, n.delta = i, n.rating = function(s, c) {
      return s > c[1] ? "poor" : s > c[0] ? "needs-improvement" : "good";
    }(n.value, t), e(n));
  };
}, M = function(e) {
  requestAnimationFrame(function() {
    return requestAnimationFrame(function() {
      return e();
    });
  });
}, P = function(e) {
  var n = function(t) {
    t.type !== "pagehide" && document.visibilityState !== "hidden" || e(t);
  };
  addEventListener("visibilitychange", n, !0), addEventListener("pagehide", n, !0);
}, b = -1, J = function() {
  return document.visibilityState !== "hidden" || document.prerendering ? 1 / 0 : 0;
}, k = function(e) {
  document.visibilityState === "hidden" && b > -1 && (b = e.type === "visibilitychange" ? e.timeStamp : 0, fn());
}, U = function() {
  addEventListener("visibilitychange", k, !0), addEventListener("prerenderingchange", k, !0);
}, fn = function() {
  removeEventListener("visibilitychange", k, !0), removeEventListener("prerenderingchange", k, !0);
}, z = function() {
  return b < 0 && (b = J(), U(), E(function() {
    setTimeout(function() {
      b = J(), U();
    }, 0);
  })), { get firstHiddenTime() {
    return b;
  } };
}, C = function(e) {
  document.prerendering ? addEventListener("prerenderingchange", function() {
    return e();
  }, !0) : e();
}, Q = [1800, 3e3], nn = function(e, n) {
  var t = w(n = n || {});
  C(function() {
    var a, o = z(), i = m("FCP"), r = I("paint", function(s) {
      s.forEach(function(c) {
        if (c.name === "first-contentful-paint") {
          t ? (c.navigationId || 1) > 1 && (d = "soft-navigation", p = c.navigationId, i = m("FCP", 0, d, p), a = g(e, i, Q, n.reportAllChanges)) : r.disconnect();
          var f = 0;
          if (c.navigationId && c.navigationId !== 1) {
            var v = Y(c.navigationId), u = (v == null ? void 0 : v.startTime) || 0;
            f = Math.max(c.startTime - u, 0);
          } else
            f = Math.max(c.startTime - N(), 0);
          (c.startTime < o.firstHiddenTime || c.navigationId && c.navigationId > 1) && (i.value = f, i.entries.push(c), i.navigationId = c.navigationId || 1, a(!0));
        }
        var d, p;
      });
    }, n);
    r && (a = g(e, i, Q, n.reportAllChanges), E(function(s) {
      i = m("FCP", 0, "back-forward-cache", i.navigationId), a = g(e, i, Q, n.reportAllChanges), M(function() {
        i.value = performance.now() - s.timeStamp, a(!0);
      });
    }));
  });
}, $ = [0.1, 0.25], vn = function(e, n) {
  var t, a, o = w(n = n || {}), i = !1;
  nn((t = function() {
    var r, s = m("CLS", 0), c = 0, f = [], v = function(p, l) {
      s = m("CLS", 0, p, l), r = g(e, s, $, n.reportAllChanges), c = 0, i = !1;
    }, u = function(p) {
      p.forEach(function(l) {
        if (o && l.navigationId && l.navigationId > s.navigationId && (c > s.value && (s.value = c, s.entries = f), r(!0), v("soft-navigation", l.navigationId)), !l.hadRecentInput) {
          var cn = f[0], un = f[f.length - 1];
          c && l.startTime - un.startTime < 1e3 && l.startTime - cn.startTime < 5e3 ? (c += l.value, f.push(l)) : (c = l.value, f = [l]);
        }
      }), c > s.value && (s.value = c, s.entries = f, r());
    }, d = I("layout-shift", u, n);
    d && (r = g(e, s, $, n.reportAllChanges), P(function() {
      u(d.takeRecords()), r(!0), i = !0;
    }), E(function() {
      v("back-forward-cache", s.navigationId), M(function() {
        return r();
      });
    }), o && I("soft-navigation", function(p) {
      p.forEach(function(l) {
        l.navigationId && l.navigationId > s.navigationId && (i || r(!0), v("soft-navigation", l.navigationId), r = g(e, s, $, n.reportAllChanges));
      });
    }, n), setTimeout(r, 0));
  }, a = !1, function(r) {
    a || (t(r), a = !0);
  }));
}, _ = { passive: !0, capture: !0 }, ln = /* @__PURE__ */ new Date(), V = function(e, n) {
  T || (T = n, A = e, W = /* @__PURE__ */ new Date(), tn(removeEventListener), en());
}, en = function() {
  if (A >= 0 && A < W - ln) {
    var e = { entryType: "first-input", name: T.type, target: T.target, cancelable: T.cancelable, startTime: T.timeStamp, processingStart: T.timeStamp + A };
    F.forEach(function(n) {
      n([e]);
    }), F = [];
  }
}, gn = function(e) {
  if (e.cancelable) {
    var n = (e.timeStamp > 1e12 ? /* @__PURE__ */ new Date() : performance.now()) - e.timeStamp;
    e.type == "pointerdown" ? function(t, a) {
      var o = function() {
        V(t, a), r();
      }, i = function() {
        r();
      }, r = function() {
        removeEventListener("pointerup", o, _), removeEventListener("pointercancel", i, _);
      };
      addEventListener("pointerup", o, _), addEventListener("pointercancel", i, _);
    }(n, e) : V(n, e);
  }
}, tn = function(e) {
  ["mousedown", "keydown", "touchstart", "pointerdown"].forEach(function(n) {
    return e(n, gn, _);
  });
}, x = [100, 300], pn = function(e, n) {
  var t = w(n = n || {});
  C(function() {
    var a, o = z(), i = m("FID"), r = function(c) {
      c.forEach(function(f) {
        var v, u;
        t ? (f.navigationId || 1) > 1 && (v = "soft-navigation", u = f.navigationId, i = m("FID", 0, v, u), a = g(e, i, x, n.reportAllChanges)) : s.disconnect(), f.startTime < o.firstHiddenTime && (i.value = f.processingStart - f.startTime, i.entries.push(f), i.navigationId = f.navigationId || 1, a(!0));
      });
    }, s = I("first-input", r, n);
    a = g(e, i, x, n.reportAllChanges), s && P(function() {
      r(s.takeRecords()), t || s.disconnect();
    }), s && E(function() {
      var c;
      i = m("FID", 0, "back-forward-cache", i.navigationId), a = g(e, i, x, n.reportAllChanges), F = [], A = -1, T = null, tn(addEventListener), c = r, F.push(c), en();
    });
  });
}, R = 0, L = 1 / 0, S = 0, j = 1, an = !1, mn = function(e) {
  e.forEach(function(n) {
    n.interactionId && (an && n.navigationId && n.navigationId > j && (j = n.navigationId, R = 0, L = 1 / 0, S = 0), L = Math.min(L, n.interactionId), S = Math.max(S, n.interactionId), R = S ? (S - L) / 7 + 1 : 0);
  });
}, on = function() {
  return D ? R : performance.interactionCount || 0;
}, hn = function(e) {
  "interactionCount" in performance || D || (an = e || !1, D = I("event", mn, { type: "event", buffered: !0, durationThreshold: 0, includeSoftNavigationObservations: e }));
}, B = [200, 500], rn = 0, Z = function() {
  return on() - rn;
}, h = [], O = {}, G = function(e) {
  var n = h[h.length - 1], t = O[e.interactionId];
  if (t || h.length < 10 || e.duration > n.latency) {
    if (t)
      t.entries.push(e), t.latency = Math.max(t.latency, e.duration);
    else {
      var a = { id: e.interactionId, latency: e.duration, entries: [e] };
      O[a.id] = a, h.push(a);
    }
    h.sort(function(o, i) {
      return i.latency - o.latency;
    }), h.splice(10).forEach(function(o) {
      delete O[o.id];
    });
  }
}, In = function(e, n) {
  var t = w(n = n || {}), a = !1;
  C(function() {
    hn(t);
    var o, i = m("INP"), r = function(v, u) {
      h = [], rn = v === "soft-navigation" ? 0 : on(), i = m("INP", 0, v, u), o = g(e, i, B, n.reportAllChanges), a = !1;
    }, s = function() {
      var v, u, d = (u = Math.min(h.length - 1, Math.floor(Z() / 50)), h[u]);
      d && (d.latency !== i.value || (v = n) !== null && v !== void 0 && v.reportAllChanges) && (i.value = d.latency, i.entries = d.entries);
    }, c = function(v) {
      v.forEach(function(u) {
        t && u.navigationId && u.navigationId > i.navigationId && (a || (s(), i.value > 0 && o(!0)), r("soft-navigation", u.navigationId)), u.interactionId && G(u), u.entryType === "first-input" && !h.some(function(d) {
          return d.entries.some(function(p) {
            return u.duration === p.duration && u.startTime === p.startTime;
          });
        }) && G(u);
      }), s(), o();
    }, f = I("event", c, { durationThreshold: n.durationThreshold || 40, opts: n });
    o = g(e, i, B, n.reportAllChanges), f && (f.observe({ type: "first-input", buffered: !0, includeSoftNavigationObservations: t }), P(function() {
      c(f.takeRecords()), i.value < 0 && Z() > 0 && (i.value = 0, i.entries = []), o(!0);
    }), E(function() {
      r("back-forward-cache", i.navigationId), M(function() {
        return o();
      });
    }), t && I("soft-navigation", function(v) {
      v.forEach(function(u) {
        u.navigationId && u.navigationId > i.navigationId && (!a && i.value > 0 && o(!0), r("soft-navigation", u.navigationId), o = g(e, i, B, n.reportAllChanges));
      });
    }, n));
  });
}, K = [2500, 4e3], yn = function(e, n) {
  var t = !1, a = w(n = n || {});
  C(function() {
    var o, i = z(), r = m("LCP"), s = function(u, d) {
      r = m("LCP", 0, u, d), o = g(e, r, K, n.reportAllChanges), t = !1;
    }, c = function(u) {
      u.forEach(function(d) {
        if (d) {
          d.navigationId && d.navigationId > r.navigationId && (t || o(!0), s("soft-navigation", d.navigationId));
          var p, l = 0;
          d.navigationId !== 1 && d.navigationId ? l = Math.max(d.startTime - (((p = Y(d.navigationId)) === null || p === void 0 ? void 0 : p.startTime) || 0), 0) : l = Math.max(d.startTime - N(), 0), d.startTime < i.firstHiddenTime && (r.value = l, r.entries = [d], r.navigationId = d.navigationId || 1, o());
        }
      });
    }, f = function() {
      t || (c(v.takeRecords()), a || v.disconnect(), t = !0, o(!0));
    }, v = I("largest-contentful-paint", c, n);
    v && (o = g(e, r, K, n.reportAllChanges), ["keydown", "click"].forEach(function(u) {
      addEventListener(u, f, !0);
    }), P(f), E(function(u) {
      s("back-forward-cache", r.navigationId), M(function() {
        r.value = performance.now() - u.timeStamp, t = !0, o(!0);
      });
    }), a && I("soft-navigation", function(u) {
      u.forEach(function(d) {
        d.navigationId && d.navigationId > r.navigationId && (t || o(!0), s("soft-navigation", d.navigationId));
      });
    }, n));
  });
}, q = [800, 1800], Tn = function e(n) {
  document.prerendering ? C(function() {
    return e(n);
  }) : document.readyState !== "complete" ? addEventListener("load", function() {
    return e(n);
  }, !0) : setTimeout(n, 0);
}, En = function(e, n) {
  var t = w(n = n || {}), a = m("TTFB"), o = g(e, a, q, n.reportAllChanges);
  Tn(function() {
    var i = H();
    if (i) {
      var r = i.responseStart;
      if (r <= 0 || r > performance.now())
        return;
      a.value = Math.max(r - N(), 0), a.entries = [i], o(!0), E(function() {
        a = m("TTFB", 0, "back-forward-cache", a.navigationId), (o = g(e, a, q, n.reportAllChanges))(!0);
      }), t && I("soft-navigation", function(s) {
        s.forEach(function(c) {
          c.navigationId && (a = m("TTFB", 0, "soft-navigation", c.navigationId), (o = g(e, a, q, n.reportAllChanges))(!0));
        });
      }, n);
    }
  });
}, wn = function(e) {
  return { evid: 180, src: 72, endpoint: "pulse", params: e };
};
const bn = [
  // GUID
  [
    /\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}(\/|$)/g,
    "/:guid$1"
  ],
  // Hexa ID
  [/\/[0-9a-fA-F]{24,}(\/|$)/g, "/:id$1"],
  // Numeric ID
  [/\/[0-9]{12}(\/|$)/g, "/:id$1"],
  // Date
  [/\/[0-9]{4}-[0-9]{2}-[0-9]{2}(\/|$)/g, "/:date$1"],
  // Form submission
  [/\/comp-[a-zA-Z0-9]{8}(\/|$)/g, "/:id$1"],
  // Remove trailing slash
  [/\/$/, ""]
], Sn = (e) => {
  const n = new URL(e);
  return bn.forEach(([t, a]) => {
    n.pathname = n.pathname.replace(t, a);
  }), n.search = "", n.toString();
};
class _n {
  constructor(n, t, a, o) {
    y(this, "_queue", /* @__PURE__ */ new Set());
    y(this, "_logger");
    y(this, "_url");
    y(this, "_platform");
    y(this, "_metadata");
    this._url = Sn(n), this._platform = t, this._logger = a, this._metadata = o;
  }
  flushQueue() {
    if (this._queue.size > 0) {
      const n = {};
      this._queue.forEach(({ name: t, value: a }) => {
        n[t] = a;
      });
      try {
        const t = JSON.stringify(n), a = JSON.stringify(this._metadata);
        this._logger.report(
          wn({
            platform: this._platform,
            url: this._url,
            webVitals: t,
            metadata: a
          })
        );
      } catch (t) {
        console.error(t);
      }
      this._queue.clear();
    }
  }
  addToQueue(n) {
    const { name: t, value: a } = n;
    this._queue.add({ name: t, value: a });
  }
}
class Cn {
  constructor(n, t, a = {}) {
    y(this, "_platform");
    y(this, "_logger");
    y(this, "_metadata");
    this._platform = n, this._logger = t, this._metadata = a, this._init();
  }
  _init() {
    const n = new _n(
      window.location.href,
      this._platform,
      this._logger,
      this._metadata
    );
    En((t) => n.addToQueue(t), { reportSoftNavs: !0 }), nn((t) => n.addToQueue(t), { reportSoftNavs: !0 }), yn((t) => n.addToQueue(t), { reportSoftNavs: !0 }), vn((t) => n.addToQueue(t), { reportSoftNavs: !0 }), pn((t) => n.addToQueue(t), { reportSoftNavs: !0 }), In((t) => n.addToQueue(t), { reportSoftNavs: !0 }), addEventListener("visibilitychange", () => {
      document.visibilityState === "hidden" && n.flushQueue();
    }), addEventListener("pagehide", n.flushQueue);
  }
}
export {
  Cn as Pulse
};
